export class AddAddressRequest {
    street: string;
    number: string;
    suffix: string;
    postalCode: string;
    city: string;
    province: string;
    country: string;
}